import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/v4ward/departmentRenter/list', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/v4ward/departmentRenter/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/v4ward/departmentRenter/remove', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/v4ward/departmentRenter/save', params, options);

export const update = (params, options) =>
  request.post('/api/v4ward/departmentRenter/update', params, options);

export const getRentRecordHistory = (params, options) =>
  request.get('/api/v4ward/departmentRentRecord/getRentRecordHistory', Object.assign({}, options, { params }));


